import { DesigntimeComponent } from './DesigntimeComponent.js'
import componentHelpers from './componentHelpers.js'
import { LiquidString } from '../common/LiquidString.js'
import * as $ from 'jquery';

class WonLostAmount extends DesigntimeComponent {
    static staticName = "Won/Lost-Amount";
    static staticId = "wonLostAmount";

    runtimeAmount = 0;
    runtimeAmountSet = false;
    runtimeWon = null;

    constructor(identifyer) {
        super(identifyer, 1);

        this.disableNextButton();

        this.values = {
            header: new LiquidString("text", `${this.id}_header`),
            beforeButtons: { value: "I have" },
            wonText: { value: "won" },
            lostText: { value: "lost" },
            currency: { value: "kr" },
            buttontext: { value: "Next" }
        };
    }

    getRuntimeView(context) {
        if (context.params.useBootstrapUi)
            return this.getRuntimeBootstrapView();

        let $view = $("<div></div>");
        $view.append("<h2>" + this.values.header.value + "</h2>")

        $view.append($(`<label>${this.values.beforeButtons.value}</label>`));

        let $wonButton = $(`<input class='sid-question-button' type='button' value='${this.values.wonText.value}' ></input >`);
        $wonButton.click(function (e) {
            componentHelpers.getRtFrame(this.id).find(".sid-question-button").removeClass("sid-button-selected");
            $(e.currentTarget).addClass("sid-button-selected");
            this.runtimeWon = true;
            this.openNextButton();
        }.bind(this));
        $view.append($wonButton);

        let $lostButton = $(`<input class='sid-question-button' type='button' value='${this.values.lostText.value}' ></input >`);
        $lostButton.click(function (e) {
            componentHelpers.getRtFrame(this.id).find(".sid-question-button").removeClass("sid-button-selected");
            $(e.currentTarget).addClass("sid-button-selected");
            this.runtimeWon = false;
            this.openNextButton();
        }.bind(this));
        $view.append($lostButton);

        $view.append($("<br />"));

        let $amount = $("<input class='sid-component-input-number'type='number'></input>");
        $amount.on('input', function (e) {
            this.runtimeAmount = $(e.currentTarget).val();
            this.runtimeAmountSet = this.runtimeAmount != "";
            this.openNextButton();
        }.bind(this));

        $view.append($amount);
        $view.append($("<label>" + this.values.currency.value + "</label>"));

        return $view;
    }

    getRuntimeBootstrapView() {
        let $view = $("<div class='mb-4 content-won-lost-amount'></div>");

        $view.append(this.values.header.getTag("h3"));

        $view.append($(`<label>${this.values.beforeButtons.value}</label>`));

        let $wonButton = $(`<button class='btn btn-light m-2'>${this.values.wonText.value}</button>`);
        $wonButton.on("click", function (e) {
            componentHelpers.getRtFrame(this.id).find(".active").removeClass("active");
            $(e.currentTarget).addClass("active");
            this.runtimeWon = true;
            this.openNextButton();
        }.bind(this));
        $view.append($wonButton);

        let $lostButton = $(`<button class='btn btn-light m-2'>${this.values.lostText.value}</button>`);
        $lostButton.on("click", function (e) {
            componentHelpers.getRtFrame(this.id).find(".active").removeClass("active");
            $(e.currentTarget).addClass("active");
            this.runtimeWon = false;
            this.openNextButton();
        }.bind(this));
        $view.append($lostButton);

        let $amount = $("<input class='form-control' type='number'></input>");
        $amount.on('input', function (e) {
            this.runtimeAmount = $(e.currentTarget).val();
            this.runtimeAmountSet = this.runtimeAmount != "";
            this.openNextButton();
        }.bind(this));

        let $inputgroup = $(`<div class="input-group"></div>`);
        $inputgroup.append($amount);
        $inputgroup.append(`<div class="input-group-text">${this.values.currency.value}</div>`);
        $view.append($inputgroup);

        return $view;
    }

    openNextButton() {
        if (this.runtimeWon != null && this.runtimeAmountSet) {
            this.enableNextButton();
        } else {
            this.disableNextButton();
        }
    }

    getOutput() {
        var real = this.runtimeAmount;
        if (!this.runtimeWon)
            real = -real;

        return {
            absamount: this.runtimeAmount,
            realamount: real,
            won: this.runtimeWon
        };
    }

    output = [
        { name: "absamount", type: "number" },
        { name: "realamount", type: "number" },
        { name: "won", type: "bool" }
    ];
}

export { WonLostAmount }
